import { DefaultTheme } from 'styled-components';

import { spacing } from 'styles/spacing';

export const getButtonLayoutStyles = ({ theme }: { theme: DefaultTheme }): string => {
  return `
    &.buttons-layout {
      display: flex;
      flex-direction: column;
      flex-basis: auto;
      @media ${theme.media_queries.mediaS} {
        flex-direction: row;
      }

      >:nth-child(n) {
        margin-right: 0rem;
        ${spacing('mt', 2)} 
        @media ${theme.media_queries.mediaS} {
          margin-top: 0rem;
          ${spacing('mr', 2)} 
        }
      }
      >:first-child {
        margin-top: 0rem;
      }
      >:last-child {
        @media ${theme.media_queries.mediaS} {
          margin-right: 0rem;
        }
      }
    }
  `;
};
